import {
  ArrowRight,
  Briefcase,
  Padlock,
  ShieldCheck,
} from '@remarkable/ark-icons';
import { SectionBlock, Typography } from '@remarkable/ark-web';
import { ComponentLocations } from 'src/analytics/trackingTypes';
import { Button } from './Button';
import { Feedback } from './Feedback';
import { Link2 } from './Link2';
import { RemarkableLogo } from './RemarkableLogo';

export const EnterpriseEnrollLanding = () => {
  return (
    <div className="mx-auto max-w-full px-16 pt-20 lm:px-64">
      <Link2
        to="/enterprise"
        inline
        className="mx-auto flex"
        componentLocation={ComponentLocations.ENTERPRISE.VALUE_PROP_PAGE}
      >
        <RemarkableLogo color="black" />
      </Link2>
      <div className="mx-auto mt-32 flex max-w-2xl flex-col items-center justify-center gap-16 ll:mt-96">
        <Typography variant="heading-xl" as="h1">
          Set up single sign-on
        </Typography>
        <Typography variant="body-md" className="text-center">
          Log in to begin the enrollment process for your company. You&apos;ll
          then be guided through the steps to enable enterprise single sign-on
          (SSO) for your organization.
        </Typography>
      </div>
      <SectionBlock
        bgColorIntensity={1}
        className="mx-auto mt-32 max-w-7xl shadow-sheet ll:mt-64"
      >
        <div className="flex flex-col justify-between gap-20 text-center ll:gap-32 lxl:flex-row">
          <div className="flex flex-col items-center">
            <Briefcase size={40} />
            <Typography
              variant="heading-subtle-md"
              className="lxl:min-h-56 l2xl:min-h-0"
            >
              Create your organization&apos;s account
            </Typography>
            <Typography variant="body-sm">
              The account you&apos;re currently logged in with will be
              designated as the owner with full administrative access.
            </Typography>
          </div>
          <div className="flex flex-col items-center">
            <ShieldCheck size={40} />
            <Typography
              variant="heading-subtle-md"
              className="lxl:min-h-56 l2xl:min-h-0"
            >
              Verify your domain
            </Typography>
            <Typography variant="body-sm">
              To complete this step, you&apos;ll need access to your
              domain&apos;s DNS settings. This is to make sure only authorized
              users from your organization can log in with SSO.
            </Typography>
          </div>
          <div className="flex flex-col items-center">
            <Padlock size={40} />
            <Typography
              variant="heading-subtle-md"
              className="lxl:min-h-56 l2xl:min-h-0"
            >
              Connect your identity provider
            </Typography>
            <Typography variant="body-sm">
              This last step requires providing the SAML URLs and certificate
              from your provider to establish a secure connection.
            </Typography>
          </div>
        </div>
      </SectionBlock>

      <Button
        variant="primary"
        className="mx-auto mt-32 ll:mt-64"
        as="a"
        to="/enterprise"
        analytics={{
          action: 'continue to enterprise setup',
          location: ComponentLocations.ENTERPRISE.VALUE_PROP_PAGE,
          text: 'Continue',
        }}
      >
        <span>Continue</span>
        <ArrowRight size={24} />
      </Button>

      <Feedback
        className="mt-64"
        title={'Did you find what you were looking for?'}
        feedbackTargetId={'enterprise-enroll-landing'}
      />
    </div>
  );
};
